import analytics from 'yoda-core-components/lib/helpers/Analytics/Analytics';
import get from 'lodash/get';

import { MY_APPOINTMENTS_PAGE_LOADED_SUCCESS } from 'yoda-site-components/lib/actionTypes/AppointmentActionTypes';
import { logwebvitals } from 'yoda-site-components/lib/middlewares/WebvitalsMiddleware';
import { buildCJALinkClick } from 'yoda-site-components/lib/analytics/CJAEventsHelper';

import cjaAnalytics from 'yoda-core-components/lib/helpers/Analytics/CJAAnalytics';
import * as CAMDashboardActionTypes from '../actionTypes/CAMDashboardActionTypes';
import * as WalletBarcodeActionTypes from '../actionTypes/WalletBarcodeActionTypes';
import { PROMOTIONAL_ANALYTICS_ACTION } from '../actionTypes/CAMDashboardActionTypes';
// eslint-disable-next-line import/no-named-as-default
import CAMActionFilter from '../analytics/CAMDashboardActionFilter';
import AppointmentActionFilter from '../analytics/AppointmentActionFilter';
import * as CJAAnalyticsService from '../services/CJAAnalyticsService';

const camActionFilter = new CAMActionFilter();
const appointmentActionFilter = new AppointmentActionFilter();
/**
 * This function will used only for redux middleware only to track tagging based on action request
 */
const AccountAnalyticsMiddleware = store => next => action => { // eslint-disable-line
    if (!__SERVER__) {
        let digitalData = null;
        let analyticsEventName = null;
        const { context } = store.getState();
        const enableCJAAnalytics = context?.featureFlags?.enableCJAAnalytics;
        /**
         * component can trigger an action only for tagging
         * action should contain analytics object as mandatory
         * @param analytics.type - {string}  - tagging key
         * @param analytics.JCPDL - {Object}  - required additional details for tagging event
         */
        try {
            switch (action.type) {
                case MY_APPOINTMENTS_PAGE_LOADED_SUCCESS:
                    digitalData = appointmentActionFilter.getAppointmentPageDL(store);
                    analyticsEventName = 'digitalDataReady';
                    logwebvitals(store, digitalData);
                    break; /* istanbul ignore next */
                case CAMDashboardActionTypes.CAM_PAGE_ANALYTICS_ACTION:
                    digitalData = camActionFilter.getCAMDashboardPageDL(store, action.payload);
                    digitalData = camActionFilter.updateCommonDigitalData(digitalData);
                    analyticsEventName = action.payload.trackEvent;
                    logwebvitals(store, digitalData);
                    break; /* istanbul ignore next */
                case PROMOTIONAL_ANALYTICS_ACTION:
                    digitalData = camActionFilter.getPromotionalEmailPreferences(
                        action.payload.preferences
                    );
                    analyticsEventName = action.payload.trackEvent;
                    break; /* istanbul ignore next */
                case WalletBarcodeActionTypes.WALLET_CAPTCHA_ANALYTICS:
                    digitalData = action.data;
                    analyticsEventName = action.eventName;
                    break;
                default:
                    break;
            }
            if (analyticsEventName || digitalData) {
                analyticsEventName === 'digitalDataReady' &&
                    // eslint-disable-next-line no-console
                    console.info('digitalData -', digitalData);
                digitalData.dataVersion = 1;
                const track = () => {
                    analytics.track(analyticsEventName, digitalData);
                };
                /* istanbul ignore if */
                if (get(digitalData, 'page.pageInfo.name', '') === 'ALMOST DONE - modal') {
                    setTimeout(track, 4000);
                } else {
                    track();
                }
            }
            if (enableCJAAnalytics) {
                let cjaData = null;
                switch (action.type) {
                    case MY_APPOINTMENTS_PAGE_LOADED_SUCCESS:
                        cjaData = CJAAnalyticsService.trackCJAPageView(store, 'my appointments');
                        break;
                    case CAMDashboardActionTypes.CAM_PAGE_ANALYTICS_ACTION:
                        cjaData = CJAAnalyticsService.trackCJAPageView(
                            store,
                            action?.payload?.pageName
                        );
                        break;
                    case PROMOTIONAL_ANALYTICS_ACTION:
                        if (action.payload?.trackEvent === 'updateNotificationOptinsDenied') {
                            const { eventName, payload } = buildCJALinkClick({
                                linkModuleName: 'updateNotificationOptions:Denied',
                            });
                            cjaData = { eventName, eventData: payload };
                        } else {
                            cjaData = CJAAnalyticsService.trackCJANotificationOptins(
                                action.payload.preferences
                            );
                        }
                        break;
                    case WalletBarcodeActionTypes.WALLET_CAPTCHA_ANALYTICS: {
                        const { eventName, payload } = buildCJALinkClick({
                            linkModuleName: `${action.eventName}:${action.data.code}`,
                        });
                        cjaData = { eventName, eventData: payload };
                        break;
                    }
                    default:
                        break;
                }
                if (cjaData) {
                    cjaAnalytics.track(cjaData.eventName, cjaData.eventData);
                }
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
        }
    }
    if (action.type) {
        return next(action);
    }
};

export default AccountAnalyticsMiddleware;
